import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, CardTitle } from "reactstrap"
import "./dashboard.css"
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"

import { deleteApplication } from "../../appRedux/slices/application"

const ApplicationCard = props => {
  const dispatch = useDispatch()

  const { application: { appName = "", appCode = "" } = {} } = props || {}

  const name = appName || appCode

  const _onEdit = applicationDetails => {
    props.onEdit(applicationDetails)
  }

  const _onDelete = async applicationDetails => {
    const { appId } = applicationDetails
    await dispatch(deleteApplication(appId))
  }

  return (
    <>
      <Card
        className={`text-center bg-gradient shadow-lg m-auto mt-4 align-self-center`}
        onClick={() => props.goToUserPage(props.application)}
        style={{ cursor: "pointer" }}
      >
        <CardBody>
          <div className="avatar-md mb-4 m-auto">
            <span
              className="avatar-title rounded-circle bg-gradient font-size-24 font-weight-semibold"
              style={{ backgroundColor: "#00a3ff" }}
            >
              {name && name.charAt(0).toUpperCase()}
            </span>
          </div>
          <CardTitle className="font-size-20">{name}</CardTitle>
        </CardBody>
        <div className="d-flex font-size-20 p-2 bg-secondary border-top text-center">
          <div className="flex-fill">
            <i
              className="bx bx-edit-alt"
              title="Edit"
              role="button"
              onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                _onEdit(props.application || {})
              }}
            />
          </div>
          {/* <div className="flex-fill">
                    <i
                        title='Delete'
                        className="bx bx-trash-alt"
                        role="button"
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            confirmAlert({
                                title: 'Delete Confirmation',
                                message: `Are you sure you want to delete ${name} Application?`,
                                buttons: [
                                    {
                                        label: 'Yes',
                                        onClick: () => _onDelete(props?.application || {})

                                    },
                                    {
                                        label: 'No',
                                        onClick: () => { }
                                    }
                                ]
                            });
                        }}
                    />
                </div> */}
        </div>
      </Card>
    </>
  )
}

export default ApplicationCard
